// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"c125713f","511":"8859573c","730":"1c534a09","748":"7438580c","858":"fe3a40e5","897":"b42b8d84"}[chunkId] + ".chunk.css";
};